import axios from 'axios';
import { useAuthStore } from '@/stores/auth';
import { getActivePinia } from 'pinia';

const appUrl = import.meta.env.VITE_APP_URL;

const axiosInstance = axios.create({
    baseURL: `${appUrl}/api`,
    timeout: 60000
});

axiosInstance.interceptors.request.use((config) => {
    const authStore = useAuthStore();

    if (authStore.isAuthenticated) {
        config.headers.Authorization = `Bearer ${authStore.token}`;
    }

    if (!config.headers['Content-Type']) {
        config.headers['Content-Type'] = 'application/json';
    }

    return config;
});

axiosInstance.interceptors.response.use(success, error);

function success(response) {
    return response.data;
}

function error(error) {
    // Handle 401 Unauthorized.
    if (error.response && error.response.status === 401) {
        getActivePinia()._s.forEach((store) => store.$reset());
        window.location = '/';
        return;
    }

    return Promise.reject(error.response);
}

export default axiosInstance;
